import React, { Component } from 'react';

import { DirtyWrapperContent } from 'Components/tracked/DirtyWrapperContent';
import { DirtyContext } from 'Components/tracked/DirtyContext';

class DirtyWrapper extends Component {
  render() {
    return (
      <DirtyContext.Consumer>
        {context => <DirtyWrapperContent {...this.props} {...context} />}
      </DirtyContext.Consumer>
    );
  }
}

export { DirtyWrapper };



// WEBPACK FOOTER //
// ./src/components/tracked/DirtyWrapper.js